import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../../../axios-local-api';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import classes from './Steering.css';

export class AlarmsSummary extends Component {
  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}

  render() {
    //console.log("[AlarmsSummary] render:", this.props);
    let alarmsSummary;
    // if(this.props.originalDevice){
    //   alarmsSummary = this.props.originalDevice.realDevices.map((element, ind, arr) => {
    if (this.props.rows && this.props.rows.length > 0) {
      alarmsSummary = this.props.rows.map((element, ind, arr) => {
        //console.log("element", element, "ind", ind, "arr", arr);
        var row = element.map((column) => {
          return (
            <div id="AlarmSummary" className={classes.CellAreaBig}>
              {column}
            </div>
          );
        });
        return (
          <Box key={ind}>
            <div
              className={[
                classes.BodyRow,
                classes.BodyRow1,
                classes.rowColor,
              ].join(' ')}
              style={{ padding: '0px', margin: '0px' }}
            >
              <div className={classes.BodyInfo}>
                <div
                  className={classes.TableRow}
                  style={{ padding: '5px 0px' }}
                >
                  {row}
                </div>
              </div>
            </div>
          </Box>
        );
      });
    } else {
      alarmsSummary = (
        <div style={{ color: 'gray' }}>
          There is no Band Steering Information available at this time
        </div>
      );
    }
    const columns = this.props.columns.map((element) => {
      return <div className={classes.HeaderAreaBig}>{element}</div>;
    });
    return (
      <Box>
        <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
          <div className={classes.BodyTitle}>
            <b>{this.props.name}</b>
          </div>
          <div className={classes.BodyInfo}>
            <div
              className={classes.TableRow}
              style={{ padding: '18px 0px 12px 0px' }}
            >
              {columns}
            </div>
            {alarmsSummary}
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AlarmsSummary, axios));
